export {default as GenrateTextarea} from './genrate-textarea.vue'